import { SmartPillData } from 'owa-smart-pill';
import { SmartPillsFeatureArrangement } from 'owa-mail-smart-pill-features';
import filterSmartPillData from './filterSmartPillData';

/**
 *  Filters pills using featureArrangement
 *  @param pills: Flat array of smart pills from mail stamp
 *  @param featureArrangement: Arrangement used to filter and positioning the pills
 */
export default function integrateSmartFeatureArrangement(
    pills: SmartPillData[],
    featureArrangement: SmartPillsFeatureArrangement
): SmartPillData[] {
    const pillsToShow: SmartPillData[] = [];

    if (featureArrangement && pills.length > 0) {
        featureArrangement.arrangement.forEach(featureName => {
            pillsToShow.push(
                ...filterSmartPillData(
                    pills,
                    featureName,
                    featureArrangement.aggregation[featureName]
                )
            );
        });
    }

    return pillsToShow;
}
